import React from "react";
import {
  Button,
  Col,
  Container,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import {
  LogisticOrderSearchCriteria,
  PageListBean,
  RestLogisticOrderListRequest,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import { InputTextbox, ShowError } from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { LogisticOrderService } from "../services/LogisticOrderService.js";
export class LogisticOrderLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name, statusList) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    // this.customerCode = customerCode;
    // this.status = status;
    this.statusList = statusList;
    let resetCriteria = new LogisticOrderSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let logisticOrderLookupCriteria = new LogisticOrderSearchCriteria();
    logisticOrderLookupCriteria.companyCode = this.companyCode;
    // logisticOrderLookupCriteria.customerCode = this.customerCode;
    logisticOrderLookupCriteria.orderStatusList = this.statusList;
    let newCriteria = new LogisticOrderSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let lookupCriteriaView = LogisticOrderLookupCriteriaHandler(
      companyCode,
      logisticOrderLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      logisticOrderLookupCriteria,
      lookupCriteriaView
    );
    ModuleUtils.getLogisticOrderStatusList();
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition(" Customer", "customerCode", 0, false); //1
    this.addColumnDefinition(" CustomerName", "customerName", 0, false); //1
    this.addColumnDefinition("Created Date", "orderDate", 0, false); //3
    this.addColumnDefinition("Container", "containerNumber", 0, false); //3
    this.addColumnDefinition("Reference#", "customerReferenceNumber", 0, false); //3
    this.addColumnDefinition("Status", "orderStatus", 0, false); //3
  }
  loadLogisticOrderList = (lookup_dialog, pageNumber, searchCriteria) => {
    let order_criteria = new LogisticOrderSearchCriteria(); //To be fetched from CriteriaHandler
    order_criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      order_criteria.logisticOrderNumberStartsWith =
        searchCriteria.logisticOrderNumberStartsWith;
      order_criteria.logisticOrderNumberContains =
        searchCriteria.logisticOrderNumberContains;
      order_criteria.logisticOrderNumber = searchCriteria.logisticOrderNumber;
      order_criteria.customerCode = searchCriteria.customerCode;
      order_criteria.containerNumber = searchCriteria.containerNumber;
      // if (isEmptyString(this.status)) {
      //   order_criteria.orderStatus = searchCriteria.orderStatus;
      // } else {
      //   order_criteria.orderStatus = this.status;
      // }
      if (isEmptyString(this.statusList)) {
        order_criteria.orderStatusList = searchCriteria.orderStatusList;
      } else {
        order_criteria.orderStatusList = this.statusList;
      }
    }
    let order_pageList = new PageListBean();
    order_pageList.pageSize = 50; //TODO --> Fetch from Config
    order_pageList.pageNumber = pageNumber;
    order_pageList.currentPage = pageNumber;
    let requestInput = new RestLogisticOrderListRequest();
    requestInput.pageInput = order_pageList;
    requestInput.criteria = order_criteria;
    LogisticOrderService.getLogisticOrderPageList(
      requestInput,
      (response) => this.loadLogisticOrderResponse(response, lookup_dialog),
      this.loadLogisticOrderError
    );
  };
  loadLogisticOrderResponse = (response, lookup_dialog) => {
    let orderList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.logisticOrderPageList) &&
      !isEmptyArray(response.data.logisticOrderPageList.logisticOrders)
    ) {
      orderList = response.data.logisticOrderPageList.logisticOrders;
      totalCount = response.data.logisticOrderPageList.totalCount;
      currentPageNumber = response.data.logisticOrderPageList.currentPage;
      pageSize = response.data.logisticOrderPageList.pageSize;
      orderList.map((pl) => {
        pl.orderStatus = ModuleUtils.getLogisticOrderStatusCaption(
          pl.orderStatus
        );
      });
    }
    let result = new Array();
    if (!isEmptyArray(this.statusList)) {
      this.statusList.map((x) => {
        let filter_array = orderList.filter(
          (ln) => ln.orderStatus == ModuleUtils.getLogisticOrderStatusCaption(x)
        );
        if (!isEmptyArray(filter_array)) result.push(...filter_array);
        // result.push(orderList.filter((ln) => ln.orderStatus == ModuleUtils.getLogisticOrderStatusCaption(x)));
      });
    }
    let lookup_result_details = new LookupResultDetails();
    if (!isEmptyArray(this.statusList)) {
      lookup_result_details.pageData = result;
    } else {
      lookup_result_details.pageData = orderList;
    }
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadLogisticOrderError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.logisticOrderNumberContains)) {
      if (!isEmptyString(filterText)) {
        search.logisticOrderNumberContains = filterText;
        this.searchCriteria = new LogisticOrderSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadLogisticOrderList(lookup_dialog, pageNumber, search);
    }
  }
}
const LogisticOrderLookupCriteriaHandler = (
  companyCode,
  logisticOrderLookupCriteria
) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new LogisticOrderSearchCriteria(),
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    }
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new LogisticOrderSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>LogisticOrderNumber</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="logisticOrderNumber"
                  name="logisticOrderNumber"
                  onChange={this.onChange}
                  value={searchCriteria.logisticOrderNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>InBound Order StartsWith</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="logisticOrderNumberStartsWith"
                  name="logisticOrderNumberStartsWith"
                  onChange={this.onChange}
                  value={searchCriteria.logisticOrderNumberStartsWith}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>InBound Order Contains</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="logisticOrderNumberContains"
                  name="logisticOrderNumberContains"
                  onChange={this.onChange}
                  value={searchCriteria.logisticOrderNumberContains}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Container Number</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="containerNumber"
                  name="containerNumber"
                  onChange={this.onChange}
                  value={searchCriteria.containerNumber}
                />
              </Col>
            </Row>

            <Row>
              <Col sm={5}>
                <FormLabel>Status</FormLabel>
              </Col>
              <Col sm={7}>
                <FormControl
                  as="select"
                  custom
                  onChange={this.onChange}
                  name="orderStatus"
                  value={searchCriteria.orderStatus}
                >
                  <option value={""}></option>
                  <option value={"A"}>Approved</option>
                  <option value={"U"}>UnApproved</option>
                  <option value={"R"}>Received</option>
                  <option value={"I"}>Partially Received</option>
                  <option value={"H"}>Force Close</option>
                  <option value={"X"}>Cancelled</option>
                </FormControl>
              </Col>
            </Row>

            <Row className="popup_criteria_button_align-lookup">
              <Button
                ref={this.focusRef}
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </Row>
          </Container>
        </div>
      );
    }
  };
};
